import { useNavigate } from 'react-router-dom';
import { LeftArrow } from '../../icons/arrows/leftArrow';
import { useEffect, useRef, useState } from 'react';
import { Button } from '../../components/ui/Button';
import { WarningIcon } from '../../icons/warningIcon';
import { useServiceCarStore } from '../../store/serviceCarStore';
import { ServiceHistory } from '../../components/service/serviceHistory';
import { ServiceOptions } from '../../components/service/serviceOptions';
import {
  useInitiateService,
  useWantBodyWork,
  useTyreWantChange,
  useServiceEndpoint,
  useUploadBodyworkFn,
} from '../../hooks/react-query/useService';
import { ServiceFields } from '../../components/service/serviceFields';
import { toast } from '../../components/ui/Toast/useToast';
import { ServiceBooking } from '../../components/service/serviceBooking';
import { ServiceSlots } from '../../components/service/serviceSlots';
import { Dialog, DialogContent } from '../../components/ui/Modal';
import { getServiceAvailabilityFn, getServiceBookingSummeryFn } from '../../transactions/serviceBooking/serviceBooking';
import { ServiceSummary } from '../../components/service/ServiceSummary';
import { useOnlinePaymentInitit } from '../../hooks/react-query/usePayment';
import usePersonStore from '../../store/personStore';
import Loader from '../../components/elements/loader';

let hasService = false;
let hasTires = false;
let hasPaint = false;
let hasAuth = false;
let serviceLight = false;

export const ServicePage = () => {
  const [loading, setLoading] = useState(false);
  const [summaryData, setSummaryData] = useState();
  const [formStep, setFormStep] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  //fields bades on the user options
  const [requiredFields, setRequiredFields] = useState();
  const [bookingInfo, setBookingInfo] = useState();
  const [timeSlots, setTimeSlots] = useState();
  const flowId = useRef();
  const { carInfo } = useServiceCarStore();
  const navigate = useNavigate();

  const { mutate: initiateService } = useInitiateService();
  const { mutate: wantBodyWork } = useWantBodyWork();
  const { mutate: tyreWantChange } = useTyreWantChange();
  const { mutate: serviceEndpoint } = useServiceEndpoint();
  const { mutate: uploadBodywork } = useUploadBodyworkFn();
  const { mutate: paymentInit } = useOnlinePaymentInitit();

  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  useEffect(() => {
    if (requiredFields !== undefined) {
      setFormStep(2);
    }
  }, [requiredFields]);

  const handleServiceSubmit = (data) => {
    setLoading(true);
    hasService =
      data.selectedServices.findIndex(
        (item) => item === 'standarizedService'
      ) !== -1;
    hasTires =
      data.selectedServices.findIndex((item) => item === 'tyreChange') !== -1;
    hasPaint =
      data.selectedServices.findIndex((item) => item === 'bodyWork') !== -1;
    hasAuth = false;
    serviceLight = false;
    if (hasService) {
      initiateService(
        {
          action: 'standarizedService',
          mileage: data.mileage.toString(),
          plateno: carInfo.plateno,
        },
        {
          onSuccess: (data) => {
            setLoading(false);
            if (data.data !== 'fail') {
              flowId.current = data.data.serviceflowId
              setSummaryData({ ...summaryData, serviceLight: false });
              if (data.data.step.name === 'wantBodyWork') {
                if (hasTires) {
                  toast({
                    variant: 'destructive',
                    description:
                      data.exceptions[0] || 'Παρουσιάστηκε κάποιο πρόβλημα',
                  });
                  setRequiredFields();
                } else {
                  wantBodyWork(
                    { flowId: flowId.current, wantBodyWork: hasPaint },
                    {
                      onSuccess: (data) => {
                        const updatedRequiredFields = {
                          ...data.object.steps,
                          fields: [],
                          current: data.data.step.name,
                        };
                        updatedRequiredFields.order.forEach((field) => {
                          if (
                            field !== 'wantBodyWork' &&
                            field !== 'booking' &&
                            updatedRequiredFields.statuses[field] === 'pending'
                          ) {
                            updatedRequiredFields.fields.push(field);
                          }
                        });
                        setRequiredFields(updatedRequiredFields);
                      },
                    }
                  );
                }
              } else if (data.data.step.name === 'authorizedService') {
                setOpenModal(true);
              } else if (data.data.step.name === 'tyreWantChange') {
                tyreWantChange(
                  { flowId: flowId.current, tyreWantChange: hasTires },
                  {
                    onSuccess: (data) => {
                      const updatedRequiredFields = {
                        ...data.object.steps,
                        fields: [],
                        current: data.data.step.name,
                      };

                      updatedRequiredFields.order.forEach((field) => {
                        if (
                          (field === 'bodyWork' ||
                            field === 'bodyWorkPhotos') &&
                          hasPaint
                        ) {
                          updatedRequiredFields.fields.push(field);
                        } else if (
                          field !== 'wantBodyWork' &&
                          field !== 'booking' &&
                          updatedRequiredFields.statuses[field] === 'pending' &&
                          field !== 'bodyWork' &&
                          field !== 'bodyWorkPhotos'
                        ) {
                          updatedRequiredFields.fields.push(field);
                        }
                      });
                      setRequiredFields(updatedRequiredFields);
                    },
                  }
                );
              } else if (data.data.step.name === 'serviceLightIndicator') {
                serviceLight = true;
                setSummaryData({ ...summaryData, serviceLight: true });
                serviceEndpoint(
                  {
                    step: 'serviceLightIndicator',
                    flowId: flowId.current,
                    data: { serviceLightIndicator: true },
                  },
                  {
                    onSuccess: (data) => {
                      if (data.data !== 'fail') {
                        if (data.data.step.name === 'authorizedService') {
                          setOpenModal(true);
                        } else {
                          if (
                            data.data.step.name === 'wantBodyWork' &&
                            hasTires
                          ) {
                            toast({
                              variant: 'destructive',
                              description: '',
                            });
                            setRequiredFields();
                          } else {
                            const updatedRequiredFields = {
                              ...data.object.steps,
                              fields: [],
                              current: data.data.step.name,
                            };
                            updatedRequiredFields.order.forEach((field) => {
                              if (field === 'tyreChange') {
                                hasTires &&
                                  updatedRequiredFields.fields.push(field);
                              } else if (
                                field === 'bodyWork' ||
                                field === 'bodyWorkPhotos'
                              ) {
                                hasPaint &&
                                  updatedRequiredFields.fields.push(field);
                              } else if (
                                field !== 'tyreWantChange' &&
                                field !== 'wantBodyWork' &&
                                field !== 'booking' &&
                                updatedRequiredFields.statuses[field] ===
                                  'pending'
                              ) {
                                updatedRequiredFields.fields.push(field);
                              }
                            });
                            if (serviceLight) {
                              updatedRequiredFields.fields.push(
                                'serviceLightIndicator'
                              );
                            }
                            setRequiredFields(updatedRequiredFields);
                          }
                        }
                      } else {
                        toast({
                          variant: 'destructive',
                          description:
                            data.exceptions[0] ||
                            'Παρουσιάστηκε κάποιο πρόβλημα',
                        });
                        setRequiredFields();
                      }
                    },
                  }
                );
              }
            } else {
              toast({
                variant: 'destructive',
                description:
                  data.exceptions[0] || 'Παρουσιάστηκε κάποιο πρόβλημα',
              });
              setRequiredFields();
            }
          },
          onError: () => {
            setLoading(false);
            toast({
              variant: 'destructive',
              description: 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
          },
        }
      );
    } else if (hasTires) {
      initiateService(
        {
          action: 'tyreChange',
          mileage: data.mileage.toString(),
          plateno: carInfo.plateno,
        },
        {
          onSuccess: (data) => {
            setLoading(false);
            if (data.data !== 'fail') {
              flowId.current = data.data.serviceflowId
              const updatedRequiredFields = {
                statuses: {
                  tyreChange: 'pending',
                  additionalComments: 'pending',
                  wantPickupDelivery: 'pending',
                  booking: 'pending',
                },
                order: [
                  'tyreChange',
                  'additionalComments',
                  'wantPickupDelivery',
                  'booking',
                ],
                fields: [],
                current: data.data.step.name,
              };

              updatedRequiredFields.order.forEach((field) => {
                if (
                  field !== 'wantBodyWork' &&
                  field !== 'booking' &&
                  updatedRequiredFields.statuses[field] === 'pending'
                ) {
                  updatedRequiredFields.fields.push(field);
                }
              });
              setRequiredFields(updatedRequiredFields);
            } else {
              toast({
                variant: 'destructive',
                description:
                  data.exceptions[0] || 'Παρουσιάστηκε κάποιο πρόβλημα',
              });
              setRequiredFields();
            }
          },
        }
      );
    } else {
      initiateService(
        {
          action: 'bodyWork',
          mileage: data.mileage.toString(),
          plateno: carInfo.plateno,
        },
        {
          onSuccess: (data) => {
            setLoading(false);
            flowId.current = data.data.serviceflowId
            const updatedRequiredFields = {
              statuses: {
                bodyWork: 'pending',
                bodyWorkPhotos: 'pending',
                additionalComments: 'pending',
                wantPickupDelivery: 'pending',
                booking: 'pending',
              },
              order: [
                'bodyWork',
                'bodyWorkPhotos',
                'additionalComments',
                'wantPickupDelivery',
                'booking',
              ],
              fields: [],
              current: data.data.step.name,
            };

            updatedRequiredFields.order.forEach((field) => {
              if (
                field !== 'wantBodyWork' &&
                field !== 'booking' &&
                updatedRequiredFields.statuses[field] === 'pending'
              ) {
                updatedRequiredFields.fields.push(field);
              }
            });
            setRequiredFields(updatedRequiredFields);
          },
        }
      );
    }
  };

  const authService = () => {
    setLoading(true)
    serviceEndpoint(
      {
        step: 'authorizedService',
        flowId: flowId.current,
        data: { authorizedService: hasAuth },
      },
      {
        onSuccess: (data) => {
          setLoading(false);
          if (data.data !== 'fail') {
            if (!hasAuth) {
              if (data.data.step.name === 'wantBodyWork' && hasTires) {
                toast({
                  variant: 'destructive',
                  description: '',
                });
                setRequiredFields();
              } else {
                const updatedRequiredFields = {
                  ...data.object.steps,
                  fields: [],
                  current: data.data.step.name,
                };
                updatedRequiredFields.order.forEach((field) => {
                  if (field === 'tyreChange') {
                    hasTires && updatedRequiredFields.fields.push(field);
                  } else if (
                    field === 'bodyWork' ||
                    field === 'bodyWorkPhotos'
                  ) {
                    hasPaint && updatedRequiredFields.fields.push(field);
                  } else if (
                    field !== 'tyreWantChange' &&
                    field !== 'wantBodyWork' &&
                    field !== 'booking' &&
                    updatedRequiredFields.statuses[field] === 'pending'
                  ) {
                    updatedRequiredFields.fields.push(field);
                  }
                });
                if (serviceLight) {
                  updatedRequiredFields.fields.push('serviceLightIndicator');
                }
                setRequiredFields(updatedRequiredFields);
              }
            } else {
              setFormStep(3);
            }
          } else {
            toast({
              variant: 'destructive',
              description:
                data.exceptions[0] || 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
            setRequiredFields();
          }
        },
      }
    );
    setOpenModal(false);
  };

  const handleFieldsSubmit = async (serviceData) => {
    setLoading(true);
    setSummaryData(serviceData);
    let endpoint = requiredFields.current;
    while (endpoint && endpoint !== 'booking') {
      switch (endpoint) {
        case 'tyreChange':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: serviceData.tyreChange,
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        case 'bodyWork':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: { bodyWork: serviceData.bodyWork },
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        case 'bodyWorkPhotos':
          //formData_1
          let formData_1 = new FormData();
          let jsonData_1 = '';

          let typeName_1 = `bodyWorkPhotos_1MimeType`;

          jsonData_1 = serviceData.bodyWorkPhotos[0];
          formData_1.set('bodyWorkPhotos_1', serviceData.bodyWorkPhotos[0]);
          formData_1.set(typeName_1, jsonData_1['type']);

          //formData_2
          let formData_2 = new FormData();
          let jsonData_2 = '';

          let typeName_2 = `bodyWorkPhotos_2MimeType`;

          jsonData_2 = serviceData.bodyWorkPhotos[1];
          formData_2.set('bodyWorkPhotos_2', serviceData.bodyWorkPhotos[1]);
          formData_2.set(typeName_2, jsonData_2['type']);

          //formData_3
          let formData_3 = new FormData();
          let jsonData_3 = '';

          let typeName_3 = `bodyWorkPhotos_3MimeType`;

          jsonData_3 = serviceData.bodyWorkPhotos[2];
          formData_3.set('bodyWorkPhotos_3', serviceData.bodyWorkPhotos[2]);
          formData_3.set(typeName_3, jsonData_3['type']);

          await new Promise((resolve) => {
            uploadBodywork(
              {
                step: endpoint,
                flowId: flowId.current,
                data: formData_1,
              },
              {
                onSuccess: (data) => {
                  uploadBodywork(
                    {
                      step: endpoint,
                      flowId: flowId.current,
                      data: formData_2,
                    },
                    {
                      onSuccess: (data) => {
                        uploadBodywork(
                          {
                            step: endpoint,
                            flowId: flowId.current,
                            data: formData_3,
                          },
                          {
                            onSuccess: (data) => {
                              serviceEndpoint(
                                {
                                  step: endpoint,
                                  flowId: flowId.current,
                                  data: { bodyWorkPhotosFinished: true },
                                },
                                {
                                  onSuccess: (data) => {
                                    setBookingInfo(data.data.step.inputs);
                                    endpoint = data.data.step.name;
                                    resolve();
                                  },
                                }
                              );
                            },
                          }
                        );
                      },
                    }
                  );
                },
              }
            );
          });
          break;
        case 'additionalComments':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: { additionalComments: serviceData.additionalComments },
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        case 'wantPickupDelivery':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: { wantPickupDelivery: serviceData.wantPickupDelivery },
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        case 'wantBodyWork':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: { wantBodyWork: hasPaint },
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        case 'tyreWantChange':
          await new Promise((resolve) => {
            serviceEndpoint(
              {
                step: endpoint,
                flowId: flowId.current,
                data: { tyreWantChange: hasTires },
              },
              {
                onSuccess: (data) => {
                  setBookingInfo(data.data.step.inputs);
                  endpoint = data.data.step.name;
                  resolve();
                },
              }
            );
          });
          break;
        default:
          endpoint = undefined;
          break;
      }
    }
    if (endpoint === 'booking') {
      setFormStep(3);
    }
    setLoading(false)
  };

  const handleBookingSubmit = (marker) => {
    setLoading(true)
    getServiceAvailabilityFn({ flowId: flowId.current, garageCode: marker.value }).then(
      (data) => {
        setLoading(false)
        if (!data.exception) {
          setTimeSlots({ markerInfo: marker, data: data.data });
          setSummaryData({ ...summaryData, marker: marker });
          setFormStep(4);
        }
      }
    );
  };

  const handleTimeSlotSubmit = (timeSlot) => {
    setSummaryData({
      ...summaryData,
      timeSlot: timeSlot,
      hasService: hasService,
      hasPaint: hasPaint,
      hasTires: hasTires,
    });
    setFormStep(5);
  };

  const onSubmitService = () => {
    setLoading(true)
    serviceEndpoint(
      {
        step: 'booking',
        flowId: flowId.current,
        data: {
          bookingCalendar: summaryData.timeSlot,
          bookingSelect: summaryData.marker.value,
        },
      },
      {
        onSuccess: (data) => {
          setLoading(false)
          getServiceBookingSummeryFn(flowId.current).then(res => {
            if (res.data.actions.findIndex(item => item.name === 'payment') !== -1) {
              paymentInit(
                {
                  serviceFlowId: flowId.current,
                  payment_type: 'pickupDelivery',
                },
                {
                  onSuccess: (response) => {
                    if (response.exceptions) {
                      if (response.exceptions.length === 0) {
                        const data = JSON.parse(response.data);
                        const url = data.url;
                        url && window.location.replace(url);
                      }
                    }
                  },
                }
              );
            } else {
              navigate(`/service-booking/summary/${flowId.current}`);
              setFormStep(0);
            }
          })
        },
      }
    );
  };

  return (
    <>
      {loading&& <Loader/>}
      <div
        className="flex flex-col gap-5 container mx-auto h-fit"
        style={{ minHeight: 'calc(100vh - 140px)' }}
      >
        <div className="flex gap-2 items-center w-full py-6">
          <LeftArrow
            className={'cursor-pointer'}
            onClick={() => {
              formStep === 4 ? setFormStep(3): formStep === 5 ? setFormStep(4): navigate(showRetailDashboard ? '/dashboard': '/portal/my-cars')  ;
            }}
          />
          <p className="h3">
            {formStep===0 ? 'Επιστροφή' :formStep === 3 ? 'Επιλογή Τοποθεσίας' : formStep === 4 ? 'Ημερομηνία & Ώρα' : formStep === 5 ? 'Επιβεβαίωση Ραντεβού' : 'Νέο Ραντεβού'}
          </p>
        </div>
        <div className="gap-5 flex max-lg:flex-col justify-center">
          {formStep !== 3 && (
            <div className="flex flex-col gap-2 border border-[#E2E2E2] rounded-[20px] max-w-[40%] p-6 h-fit max-lg:hidden">
              <div className="flex justify-between items-center">
                <p className="text-body-large">{carInfo.MakeName}</p>
                <Button
                  className={
                    'rounded-full border border-[#A5A5A5] flex xl:gap-2 py-2 px-5 items-center'
                  }
                  onClick={() => {
                    navigate('/service/notifications_guide');
                  }}
                >
                  <WarningIcon />
                  <p className='text-body'>Οδηγός Ενδείξεων</p>
                </Button>
              </div>
              <img
                alt={`${carInfo.MakeName}_${carInfo.ModelName}`}
                src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${carInfo.MakeName}&modelFamily=${carInfo.ModelName}&modelVariant=${carInfo.ModelName}&modelYear=${carInfo.ModelYear}&powerTrain=hybrid&trim=eu&zoomtype=fullscreen&angle=28`}
              />
              <div className='w-full justify-between flex'>
                <div>
                  <h6>Ημερομηνία Προσφοράς</h6>
                  <p className="text-body">{carInfo.FirstLicenseDate.split('-')[2] +'/'+ carInfo.FirstLicenseDate.split('-')[1] +'/'+ carInfo.FirstLicenseDate.split('-')[0]}</p>
                </div>
                <div>
                  <h6>Λήξη Συμβολαίου</h6>
                  <p className="text-body">{carInfo.EndDate.split('-')[2] +'/'+ carInfo.EndDate.split('-')[1] +'/'+ carInfo.EndDate.split('-')[0]}</p>
                </div>
              </div>
            </div>
          )}
          {formStep === 0 && 
            <div className="flex flex-col gap-2 border border-[#E2E2E2] rounded-[20px] p-6 h-fit lg:hidden">
              <div className="flex justify-between items-center">
                <p className="text-body-large">{carInfo.MakeName}</p>
                <Button
                  className={
                    'rounded-full border border-[#A5A5A5] flex gap-2 py-2 px-2 items-center'
                  }
                  onClick={() => {
                    navigate('/service/notifications_guide');
                  }}
                >
                  <WarningIcon />
                </Button>
              </div>
              <img
                alt={`${carInfo.MakeName}_${carInfo.ModelName}`}
                src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${carInfo.MakeName}&modelFamily=${carInfo.ModelName}&modelVariant=${carInfo.ModelName}&modelYear=${carInfo.ModelYear}&powerTrain=hybrid&trim=eu&zoomtype=fullscreen&angle=28`}
              />
              <div className='w-full justify-between flex'>
                <div>
                  <h6>Ημερομηνία Προσφοράς</h6>
                  <p className="text-body">{carInfo.FirstLicenseDate.split('-')[2] +'/'+ carInfo.FirstLicenseDate.split('-')[1] +'/'+ carInfo.FirstLicenseDate.split('-')[0]}</p>
                </div>
                <div>
                  <h6>Λήξη Συμβολαίου</h6>
                  <p className="text-body">{carInfo.EndDate.split('-')[2] +'/'+ carInfo.EndDate.split('-')[1] +'/'+ carInfo.EndDate.split('-')[0]}</p>
                </div>
              </div>
            </div>
          }
          {formStep === 0 && <ServiceHistory setFormStep={setFormStep} />}
          {formStep === 1 && (
            <ServiceOptions
              setFormStep={setFormStep}
              handleServiceSubmit={handleServiceSubmit}
              // loadingServices={loading}
            />
          )}
          {formStep === 2 && (
            <ServiceFields
              setFormStep={setFormStep}
              requiredFields={requiredFields.fields}
              handleFieldsSubmit={handleFieldsSubmit}
            />
          )}
          {formStep === 3 && (
            <ServiceBooking
              setFormStep={setFormStep}
              hasAuth={hasAuth}
              bookingInfo={bookingInfo}
              handleBookingSubmit={handleBookingSubmit}
            />
          )}
          {formStep === 4 && (
            <ServiceSlots
              setFormStep={setFormStep}
              timeSlots={timeSlots}
              handleTimeSlotSubmit={handleTimeSlotSubmit}
            />
          )}
          {formStep === 5 && (
            <ServiceSummary
              onSubmitService={onSubmitService}
              setFormStep={setFormStep}
              summaryData={summaryData}
            />
          )}
        </div>
      </div>
      <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
        <DialogContent>
          <div className="bg-white rounded-[12px] p-10 gap-6 flex flex-col items-center">
            <h3>Εξουσιοδοτημένο Service</h3>
            <p className="text-body">
              Βάσει του συμβολαίου σου, δικαιούσαι εξουσιοδοτημένο service. Επιθυμείς να επισκεφτείς ένα εξουσιοδοτημένο συνεργείο;
            </p>
            <div className="flex gap-4">
              <Button
                onClick={() => {
                  hasAuth = false;
                  authService();
                }}
                className={
                  'rounded-[6px] border border-[#A5A5A5] py-3 px-10 h6'
                }
              >
                Όχι
              </Button>
              <Button
                onClick={() => {
                  hasAuth = true;
                  authService();
                }}
                className={
                  'rounded-[6px] bg-[#D4002A] py-3 px-10 text-white h6'
                }
              >
                Ναι
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
